<app-page-heading [key]="(isCreation ? 'truck-journeys.detail.page-title-new' : 'truck-journeys.detail.page-title')">
    <div class="page-heading-left-content">
        <button type="button" class="btn btn-primary btn-outline btn-lg pull-left"
                (click)="exitDetail()">
            <span class="fa fa-arrow-left"> </span>
        </button>
    </div>
    <app-carrier-sync class="page-heading-right-content" [carrierId]="carrierId"></app-carrier-sync>
</app-page-heading>

<form #truckjourneyForm="ngForm" (submit)="save()">
    <div class="container-fluid">
        <div class="ibox">
            <div class="ibox-content searchBox">
                <h2 [i18n]="'truck-journeys.detail.general-information'"></h2>
                <div class="row">
                    <div class="col-xs-6">
                        <div class="form-group">
                            <label for="vehicle" [i18n]="'truck-journeys.detail.fields.vehicle'">
                            </label>
                            <span class="required-asterisk">*</span>
                            <input class="form-control" name="vehicle" id="vehicle" type="text"
                                   [(ngModel)]="entity.vehicle" required>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="form-group">
                            <input type="hidden" name="plannedDate" [(ngModel)]="entity.plannedPickupDate" required="true">
                            <app-data-filter-date
                                [labelKey]="'truck-journeys.detail.fields.planned-departure-date.name'"
                                [(model)]="entity.plannedPickupDate"
                                (modelChange)="truckjourneyForm.form.markAsDirty()"
                                [minDate]="yesterday"
                                [required]="true">
                            </app-data-filter-date>
                            <div class="flex-row info">
                                <i class="fa fa-info-circle"></i>
                                <span class="help-block m-b-none" [i18n]="'truck-journeys.detail.fields.planned-departure-date.help'"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ibox">
            <div class="ibox-content">
                <div class="flex-row assignedLoads-head">
                    <div class="flex-auto">
                        <h2 [i18n]="'truck-journeys.detail.assigned-loads'"></h2>
                    </div>
                    <div class="flex-auto">
                        <span *ngIf="unassignedLoadsNumber>0" [i18n]="[{target: 'innerHTML', key: 'truck-journeys.detail.loads-will-be-unassigned',
                            params: { loadsNumber: unassignedLoadsNumber }}]"></span>
                    </div>

                    <button type="button" class="btn btn-secondary btn-i btn-outline"
                            [disabled]="entity.vehicle === undefined"
                            (click)="addLoads()">
                        <i class="fa fa-plus"></i>
                        <span [i18n]="'truck-journeys.detail.button.add-loads'"></span>
                    </button>
                </div>
                <div class="assignedLoads-info-container">
                    <div class="flex-row" *ngFor="let truckJourneyLoad of entity.loads; let index=index">
                        <div class="assignedLoads-info-side">
                            <i [class._active]="index>0"
                               (click)="index>0 ? moveLoadToNewPosition(index, index-1) : noop()"
                               class="fas fa-angle-up"></i>
                            <div class="font-bold">{{ index + 1 }}</div>
                            <i [class._active]="index<entity.loads.length-1"
                               (click)="index<entity.loads.length-1 ? moveLoadToNewPosition(index, index+1) : noop()"
                               class="fas fa-angle-down"></i>
                        </div>
                        <div class="flex-auto">
                            <app-truck-journey-load *ngIf="index!==editingLoadIndex"
                                                    [truckJourneyLoad]="truckJourneyLoad"
                                                    [editableLoad]="true"
                                                    [deletableLoad]="true"
                                                    (onEditLoad)="editLoad(index)"
                                                    (onDeleteLoad)="deleteLoad(index)">
                            </app-truck-journey-load>
                            <app-truck-journey-edit-load *ngIf="index===editingLoadIndex && entity.loadEdits[index]"
                                                         [(truckJourneyLoad)]="entity.loadEdits[index]"
                                                         (truckJourneyLoadChange)="applyEditLoadChanges(index)"
                                                         (isEditingChange)="changeEditStatus($event)"
                                                         (onEditStop)="stopEditLoad()">
                            </app-truck-journey-edit-load>
                        </div>
                    </div>
                </div>
                <div *ngIf="!entity.loads || entity.loads.length === 0" class="noLoads">
                    <i class="fas fa-cube"></i>
                    <span [i18n]="'truck-journeys.detail.no-assigned-loads'"></span>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-buttons">
        <div class="form-error" *ngIf="truckjourneyForm.invalid && formErrorMessageKey"
             [i18n]="formErrorMessageKey">
        </div>
        <button class="btn btn-default" *ngIf="isCreation" type="button"
                (click)="cancelAndExit()">
            <span [i18n]="'truck-journeys.detail.button.cancel'"></span>
        </button>
        <button class="btn btn-danger" *ngIf="!isCreation" type="button"
                (click)="delete()">
            <span [i18n]="'truck-journeys.detail.button.delete'"></span>
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="isSaveDisabled() || (isLoading | async)">
            <span [i18n]="(isCreation ? 'truck-journeys.detail.button.create' : 'truck-journeys.detail.button.save')">
            </span>
        </button>
    </div>
    <app-truck-journey-load-assignment-overlay [truckJourneyLabel]="getTruckJourneyContextLabel()"
                                               [(isShowing)]="isShowingLoadAssignment"
                                               [(selectedLoads)]="loadAssignments"
                                               [truckJourney]="entity"
                                               (selectedLoadsChange)="assignLoadsToTruckJourney()">
    </app-truck-journey-load-assignment-overlay>
</form>

<app-modal #appModal [orphan]="true"></app-modal>
<ng-template #goBackModal>
    <span [i18n]="[{target: 'innerHTML', key: 'truck-journeys.detail.go-back.content'}]"></span>
</ng-template>
<ng-template #deleteModalContent>
    <span [i18n]="[{target: 'innerHTML', key: 'truck-journeys.detail.delete-modal.content'}]"></span>
</ng-template>
